import { render, staticRenderFns } from "./WireTransferRequest.vue?vue&type=template&id=403107b6&scoped=true"
import script from "./WireTransferRequest.vue?vue&type=script&lang=js"
export * from "./WireTransferRequest.vue?vue&type=script&lang=js"
import style0 from "./WireTransferRequest.vue?vue&type=style&index=0&id=403107b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403107b6",
  null
  
)

export default component.exports